<script lang="ts" setup>
import img1 from "@/assets/image/hero/hero-klimatizacija.png";
import img2 from "@/assets/image/services/airConditioning/klimatizacija-carousel-2.png";
import img3 from "@/assets/image/services/airConditioning/klimatizacija-carousel-3.png";
import air_purifier from "@/assets/image/services/airConditioning/icons/air_purifier.svg";
import android_wifi_3_bar from "@/assets/image/services/airConditioning/icons/android_wifi_3_bar.svg";
import energy_savings_leaf from "@/assets/image/services/airConditioning/icons/energy_savings_leaf.svg";
import handyman from "@/assets/image/services/airConditioning/icons/handyman.svg";
import household_supplies from "@/assets/image/services/airConditioning/icons/household_supplies.svg";
import license from "@/assets/image/services/airConditioning/icons/license.svg";
import valve from "@/assets/image/services/airConditioning/icons/valve.svg";
import { $t } from "@/i18n";
import { useDefaultStore } from "@/store";
import { $te } from "@/assets/ts/helpers";

const store = useDefaultStore();

useHead({
  title: `${$te("app.airConditioning.heading")} | ${store.SITE_NAME}`,
  meta: [
    {
      name: "title",
      content: `${$te("app.airConditioning.heading")} | ${store.SITE_NAME}`,
    },
    {
      name: "description",
      content: $te("app.airConditioning.paragraph1"),
    },
    { name: "robots", content: "index, follow" },
    {
      property: "og:title",
      content: `${$te("app.airConditioning.heading")} | ${store.SITE_NAME}`,
    },
    {
      property: "og:description",
      content: $te("app.airConditioning.paragraph1"),
    },
    { property: "og:site_name", content: store.SITE_NAME },
  ],
});

const carousel = computed(() => [
  {
    image: img1,
    text: $t("app.airConditioning.carousel.1"),
    active: true,
  },
  {
    image: img2,
    text: $t("app.airConditioning.carousel.2"),
    active: false,
  },
  {
    image: img3,
    text: $t("app.airConditioning.carousel.3"),
    active: false,
  },
]);

const info = computed(() => [
  {
    icon: handyman,
    title: $t("app.airConditioning.info.1.title"),
    text: $t("app.airConditioning.info.1.text"),
  },
  {
    icon: valve,
    title: $t("app.airConditioning.info.2.title"),
    text: $t("app.airConditioning.info.2.text"),
  },
  {
    icon: air_purifier,
    title: $t("app.airConditioning.info.3.title"),
    text: $t("app.airConditioning.info.3.text"),
  },
  {
    icon: energy_savings_leaf,
    title: $t("app.airConditioning.info.4.title"),
    text: $t("app.airConditioning.info.4.text"),
  },
  {
    icon: household_supplies,
    title: $t("app.airConditioning.info.5.title"),
    text: $t("app.airConditioning.info.5.text"),
  },
  {
    icon: android_wifi_3_bar,
    title: $t("app.airConditioning.info.6.title"),
    text: $t("app.airConditioning.info.6.text"),
  },
  {
    icon: license,
    title: $t("app.airConditioning.info.7.title"),
    text: $t("app.airConditioning.info.7.text"),
  },
]);
</script>

<template>
  <m-page class="bg-text-dark">
    <div class="mx-auto max-w-screen-xl">
      <services-page-heading :heading="$t('app.airConditioning.heading')"></services-page-heading>
      <services-paragraph class="mb-8 max-w-[779px]" :text="$t('app.airConditioning.paragraph1')"></services-paragraph>
      <base-button :text="$t('app.base.contactUs')" route-name="ContactPage" bg-color="text-light" class="mb-12 md:mb-22"></base-button>
      <div class="mb-8 grid gap-6 md:mb-22 md:grid-cols-2">
        <services-info-card v-for="(i, index) in info" :key="index" :icon="i.icon" :title="i.title" :text="i.text"></services-info-card>
      </div>
      <carousel-comp v-if="!store.isWiderThan1307" :carousel="carousel">
        <template #default="{ item, active }">
          <services-image-card :text="item.text ?? ''" :image="item.image" :active="active"></services-image-card>
        </template>
      </carousel-comp>
      <template v-else> <services-wide-carousel :carousel="carousel"></services-wide-carousel> </template>
      <services-paragraph class="mt-8" :text="$t('app.airConditioning.paragraph2')"></services-paragraph>
    </div>
  </m-page>
</template>
